// @flow

type Option = {
  value: string,
  label: string,
};

const popularityOptions: Array<Option> = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];
export default popularityOptions;
